<footer class="footer fixed-bottom">
  <div class="container">
    <div class="row py-2">
      <div class="col-12">
        <div class="info-content d-flex justify-content-between">
          <div class="info-copyright">
            &copy; {{ year }} {{ configService.ownerName }} | Vat N. {{ configService.ownerVatNumber }} |
            Crafted by <a href="https://sitisrl.it/?utm_source=archedi" title="Web Agency Milano" target="_blank">Web
              Agency Milano</a> |
            <a href="https://api.archedi.it/uploads/privacy-webapp.pdf" title="Privacy Policy" target="_blank">Privacy policy</a>
          </div>
        </div> <!-- /.info-content -->
      </div> <!-- /.col-12 -->
    </div> <!-- /.row -->
  </div>
</footer>